import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_TITLE = 'EM_T_NOTICE';

const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    isShow: false,
    title: DEFAULT_TITLE,
    message: [],
    callback: () => {},
    isDelCloseButton: false,
  },
  reducers: {
    open: (state, { payload: { title, message, callback, isDelCloseButton } }) => {
      state.isShow = true;
      state.title = title || DEFAULT_TITLE;
      state.message = message;
      state.callback = callback || (() => {});
      state.isDelCloseButton = isDelCloseButton;
    },
    close: state => {
      state.isShow = false;
    },
  },
});

export const { open, close } = alertSlice.actions;
export default alertSlice.reducer;
